import { createRouter, createWebHashHistory } from 'vue-router'
import base from "../views/base"
const routes = [
	{
		path: '/',
		redirect: '/home',
	},
	{
		path: '/base',
		name: 'base',
		component: base,
		children: [
			{
				path: '/home',
				name: 'home',
				component: () => import('../views/transitionPage/homeSMRT.vue')
			},
			{
				path: '/smrt',
				name: 'smrt',
				component: () => import('../views/homeSmartMerchant.vue')
			},
			{
				path: '/allMerchantList',
				name: 'allMerchantList',
				component: () => import('../views/transitionPage/homeAllMerchant.vue')
			},
			{
				path: '/allMerchant',
				name: 'allMerchant',
				component: () => import('../views/homeAllMerchant.vue')
			},
			{
				path: '/qrReader',
				name: 'qrReader',
				component: () => import('../views/qrReader.vue')
			},
			{
				path: '/OrderHistory',
				name: 'OrderHistory',
				component: () => import('../views/OrderHistory.vue')
			},
			{
				path: '/StoredcardHistory',
				name: 'StoredcardHistory',
				component: () => import('../views/StoredcardHistory.vue')
			},
		]
	},
	{
		path: '/myProfile',
		name: 'myProfile',
		component: () => import('../views/myProfile.vue')
	},
	{
		path: '/PayQrCode',
		name: 'PayQrCode',
		component: () => import('../views/PayQrCode.vue')
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/sso/login.vue')
	},
	{
		path: '/loginWidthMobile',
		name: 'loginWidthMobile',
		component: () => import('../views/loginWithMobile.vue')
	},
	{
		path: '/whitePage',
		name: 'whitePage',
		component: () => import('../views/whitePage.vue')
	},
	{
		path: '/Customiseitems',
		name: 'Customiseitems',
		component: () => import('../views/Customiseitems.vue')
	},
	{
		path: '/menuV1/:pathMatch(.*)*',
		component: () => import('../views/Soldout.vue')
	},
	{
		path: '/menuV2/:pathMatch(.*)*',
		component: () => import('../views/V2/SoldoutV2.vue')
	},
	{
		path: '/menu/:pathMatch(.*)*',
		component: () => import('../views/transitionPage/transSoldoutNewOld.vue')
	},
	{
		path: '/SoldoutGrabFood',
		name: 'SoldoutGrabFood',
		component: () => import('../views/SoldoutGrabFood.vue')
	},
	{
		path: '/yourorderV1',
		name: 'yourorderV1',
		component: () => import('../views/yourorder.vue')
	},
	{
		path: '/yourorderV2',
		name: 'yourorderV2',
		component: () => import('../views/V2/yourorderV2.vue')
	},
	{
		path: '/yourorder',
		name: 'yourorder',
		component: () => import('../views/transitionPage/transYourOrderNewOld.vue')
	},
	{
		path: '/deliveryaddress',
		name: 'deliveryaddress',
		component: () => import('../views/deliveryaddress.vue')
	},
	{
		path: '/Adddelivery',
		name: 'Adddelivery',
		component: () => import('../views/Adddelivery.vue')
	},
	{
		path: '/EditDelivery',
		name: 'EditDelivery',
		component: () => import('../views/EditDelivery.vue')
	},
	{
		path: '/forgotpassword',
		name: 'forgotpassword',
		component: () => import('../views/forgotpassword.vue')
	},
	{
		path: '/DineInQrCode',
		name: 'DineInQrCode',
		component: () => import('../views/DineInQrCode.vue')
	},
	{
		path: '/Verifyaccount',
		name: 'Verifyaccount',
		component: () => import('../views/Verifyaccount.vue')
	},
	{
		path: '/payM',
		name: 'payM',
		component: () => import('../views/pay.vue')
	},
	{
		path: '/stripeCheckoutForm',
		name: 'stripeCheckoutForm',
		component: () => import('../views/stripePay/SrCheckoutForm.vue')
	},
	{
		path: '/stripeReturn',
		name: 'stripeReturn',
		component: () => import('../views/stripePay/SrReturn.vue')
	},
	{
		path: '/curlecPayment',
		name: 'curlecPayment',
		component: () => import('../views/curlecPay/paymentForm.vue')
	},
	{
		path: '/xenditPayment',
		name: 'xenditPayment',
		component: () => import('../views/webPayZJ/xendit.vue')
	},
	{
		path: '/paySuccessLoadV2',
		name: 'paySuccessLoadV2',
		component: () => import('../views/componentsSS/paySuccessLoadV2.vue')
	},
	{
		path: '/pastOrderDetail',
		name: 'pastOrderDetail',
		component: () => import('../views/pastOrderDetail.vue')
	},
	{
		path: '/pastOrderDetailNoLogin',
		name: 'pastOrderDetailNoLogin',
		component: () => import('../views/pastOrderDetailNoLogin.vue')
	},
	{
		path: '/pay/:pathMatch(.*)*',
		name: 'pay',
		component: () => import('../views/payStatus.vue')
	},
	{
		path: '/payLoading',
		name: 'payLoading',
		component: () => import('../views/payLoading.vue')
	},
	{
		path: '/posReciveLoading',
		name: 'posReciveLoading',
		component: () => import('../views/componentsSS/posReciveLoading.vue')
	},
	{
		path: '/cashierCounter',
		name: 'cashierCounter',
		component: () => import('../views/cashierCounter.vue')
	},
	{
		path: '/PChome',
		name: 'PChome',
		component: () => import('../views/PCView/PChome.vue')
	},
	{
		path: '/PCCustomiseitems',
		name: 'PCCustomiseitems',
		component: () => import('../views/PCView/PCCustomiseitems.vue')
	},
	{
		path: '/PCmenu/:pathMatch(.*)*',
		component: () => import('../views/PCView/PCSoldout.vue')
	},
	{
		path: '/PCyourorder',
		name: 'PCyourorder',
		component: () => import('../views/PCView/PCyourorder.vue')
	},
	{
		path: '/PCmyProfile',
		name: 'PCmyProfile',
		component: () => import('../views/PCView/PCmyProfile.vue')
	},
	{
		path: '/PCDineInQrCode',
		name: 'PCDineInQrCode',
		component: () => import('../views/PCView/PCDineInQrCode.vue')
	},
	{
		path: '/PCdeliveryaddress',
		name: 'PCdeliveryaddress',
		component: () => import('../views/PCView/PCdeliveryaddress.vue')
	},
	{
		path: '/PCCategories',
		name: 'PCCategories',
		component: () => import('../views/PCView/PCCategories.vue')
	},
	{
		path: '/whitePageSoldout',
		name: 'whitePageSoldout',
		component: () => import('../views/whitePageSoldout.vue')
	},
	{
		path: '/homeSec',
		name: 'homeSec',
		component: () => import('../views/homeSec.vue')
	},
	{
		path: '/netsPay',
		name: 'netsPay',
		component: () => import('../views/netsPay.vue')
	},
	{
		path: '/shopbackPay',
		name: 'shopbackPay',
		component: () => import('../views/shopbackPay.vue')
	},
	{
		path: '/adyenPayForm',
		name: 'adyenPayForm',
		component: () => import('../views/adyenPay/adyenPayForm.vue')
	},
	{
		path: '/getAdyenPayRes',
		name: 'getAdyenPayRes',
		component: () => import('../views/adyenPay/getAdyenPayRes.vue')
	},
	{
		path: '/loginVerify',
		name: 'loginVerify',
		component: () => import('../views/sso/loginVerify.vue')
	},
	{
		path: '/createAcountSuccess',
		name: 'createAcountSuccess',
		component: () => import('../views/sso/createSuccess.vue')
	},
	{
		path: '/editAccount',
		name: 'editAccount',
		component: () => import('../views/sso/CreateAccount.vue')
	},
	{
		path: '/vertifyUserInfo',
		name: 'vertifyUserInfo',
		component: () => import('../views/sso/vertifyUserInfo.vue')
	},
	{
		path: '/pwdRestStepTwo',
		name: 'pwdRestStepTwo',
		component: () => import('../views/sso/pwdRestStepTwo.vue')
	},
	{
		path: '/pwdRestStepThree',
		name: 'pwdRestStepThree',
		component: () => import('../views/sso/pwdRestStepThree.vue')
	},
	{
		path: '/homeMB',
		name: 'homeMB',
		component: () => import('../views/crmVersion/homeCRM.vue')
	},
	{
		path: '/myprofileMB',
		name: 'myprofileMB',
		component: () => import('../views/crmVersion/myprofile.vue')
	},
	{
		path: '/SoldoutMB',
		name: 'SoldoutMB',
		component: () => import('../views/crmVersion/SoldoutMB.vue')
	},
	{
		path: '/orderMB',
		name: 'orderMB',
		component: () => import('../views/crmVersion/orderMB.vue')
	},
	{
		path: '/yourorderMB',
		name: 'yourorderMB',
		component: () => import('../views/crmVersion/yourorderMB.vue')
	},
	{
		path: "/voucherList",
		name: "voucherList",
		component: () => import("../views/crmVersion/rewardList.vue"),
	},
	{
		path: "/pastVoucherList",
		name: "pastVoucherList",
		component: () => import("../views/crmVersion/rewardPastList.vue"),
	},
	{
		path: "/voucherDetail",
		name: "voucherDetail",
		component: () => import("../views/crmVersion/rewardDetail.vue"),
	},
	{
		path: "/acceptVoucher",
		name: "acceptVoucher",
		component: () => import("../views/crmVersion/acceptVoucher.vue"),
	},
	{
		path: "/voucherDetailPast",
		name: "voucherDetailPast",
		component: () => import("../views/crmVersion/rewardDetailPast.vue"),
	},
	{
		path: "/crmscan",
		name: "crmscan",
		component: () => import("../views/crmVersion/scan.vue"),
	},
	{
		path: "/H5scanSuccess",
		name: "H5scanSuccess",
		component: () => import("../views/crmVersion/scanSuccess.vue"),
	},
	{
		path: "/pointExchange",
		name: "pointExchange",
		component: () => import("../views/crmVersion/pointExchange.vue"),
	},
	{
		path: "/punchExchange",
		name: "punchExchange",
		component: () => import("../views/crmVersion/punchExchange.vue"),
	},
	{
		path: "/cardUsageRecord",
		name: "cardUsageRecord",
		component: () => import("../views/crmVersion/cardLog.vue"),
	},
	{
		path: "/rechargeStoreValue",
		name: "rechargeStoreValue",
		component: () => import("../views/crmVersion/rechargeStoreValue.vue"),
	},
	{
		path: "/stripePayMB",
		name: "stripePayMB",
		component: () => import("../views/crmVersion/stripeRecharge.vue"),
	},
	{
		path: "/stripeMBReturn",
		name: "stripeMBReturn",
		component: () => import("../views/crmVersion/stripeRechargeReturn.vue"),
	},
	{
		path: "/paySuccessLoadMB",
		name: "paySuccessLoadMB",
		component: () => import("../views/crmVersion/paySuccessLoad.vue"),
	},
	{
		path: "/selectStoreMB",
		name: "selectStoreMB",
		component: () => import("../views/crmVersion/selectStore.vue"),
	},
	{
		path: "/cashierCounterMB",
		name: "cashierCounterMB",
		component: () => import("../views/crmVersion/cashierCounter.vue"),
	},
	{
		path: "/accountCardVoucherListMB",
		name: "accountCardVoucherListMB",
		component: () => import("../views/crmVersion/accountCardVoucherList.vue"),
	},
	{
		path: "/pointsRulesMB",
		name: "pointsRulesMB",
		component: () => import("../views/crmVersion/pointsRules.vue"),
	},
	{
		path: "/inviteNewMemberMB",
		name: "inviteNewMemberMB",
		component: () => import("../views/crmVersion/inviteNewMember.vue"),
	},
	{
		path: "/inviteNewDetail",
		name: "inviteNewDetail",
		component: () => import("../views/crmVersion/inviteNewDetail.vue"),
	},
	{
		path: "/handleUrlMB",
		name: "handleUrlMB",
		component: () => import("../views/crmVersion/handleUrl.vue"),
	},
	{
		path: "/claimVoucher",
		name: "claimVoucher",
		component: () => import("../views/crmVersion/claimVoucher.vue"),
	},
	{
		path: "/handleUrlMBAutoBe",
		name: "handleUrlMBAutoBe",
		component: () => import("../views/crmVersion/handleUrl2.vue"),
	},
	{
		path: "/storeValueCardDetail",
		name: "storeValueCardDetail",
		component: () => import("../views/crmVersion/storeValueCardDetail.vue"),
	},
	{
		path: "/continuePayment",
		name: "continuePayment",
		component: () => import("../views/crmVersion/yourorderRePay.vue"),
	},
	{
		path: "/webviewPayment",
		name: "webviewPayment",
		component: () => import("../views/webViewZJ/webviewPayment.vue"),
	},
	{
		path: "/webviewAdyen",
		name: "webviewAdyen",
		component: () => import("../views/webViewZJ/adyenPay/adyenPayForm.vue"),
	},
	{
		path: "/webviewAdyenRes",
		name: "webviewAdyenRes",
		component: () => import("../views/webViewZJ/adyenPay/getAdyenPayRes.vue"),
	},
	{
		path: "/webviewStripe",
		name: "webviewStripe",
		component: () => import("../views/webViewZJ/stripePay/SrCheckoutForm.vue"),
	},
	{
		path: "/webviewStripeRes",
		name: "webviewStripeRes",
		component: () => import("../views/webViewZJ/stripePay/SrReturn.vue"),
	},
	{
		path: "/registerVerify",
		name: "registerVerify",
		component: () => import("../views/sso/registerVerify.vue"),
	},
	{
		path: "/resetEmailPwd",
		name: "resetEmailPwd",
		component: () => import("../views/sso/resetEmailPwd.vue"),
	},
	{
		path: "/:pathMath(.*)",
		redirect: "/home"
	}
]

const router = createRouter({
	history: createWebHashHistory(process.env.BASE_URL),
	routes
})


export default router
